import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-77">
      <div className="bg-brand-cream border-2 border-brand-rose/20 p-6 rounded-xl text-center shadow-md" data-id="element-78">
        <p className="text-sm font-button font-bold text-brand-rose uppercase tracking-widest mb-3" data-id="element-79">
          VOTRE ACHAT EST ENTIÈREMENT PROTÉGÉ
        </p>
        <div className="w-14 h-14 mx-auto bg-brand-rose/10 rounded-full flex items-center justify-center mb-4" data-id="element-80">
          <ShieldCheck className="w-7 h-7 text-brand-rose" data-id="element-81" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-bold text-brand-title mb-3 uppercase leading-tight" data-id="element-82">
          🛡️ Garantie satisfait ou remboursé pendant 7 jours
        </h3>
        <p className="text-sm sm:text-base text-brand-text font-medium leading-relaxed" data-id="element-83">
          Votre achat est totalement sans risque. Prenez sept jours complets
          pour découvrir l'ensemble du système. Explorez chacun des modules,
          préparez vos premiers cours, utilisez les ressources pédagogiques et
          mettez immédiatement en pratique le système avec vos élèves. Si, pour
          une quelconque raison, vous n'êtes pas entièrement satisfait,
          contactez-nous simplement dans les sept premiers jours et nous vous
          rembourserons 100 % de votre achat. Aucun risque. Aucune
          justification.
        </p>
      </div>
    </section>;
}